import * as React from "react";
import { IdStyles } from "../../less/IdStyles";
import { InventoryResourceRequirement } from "../generic/inventory-resource-requirement/InventoryResourceRequirement";
export var RequirementsRecipe = function (_a) {
    var requirements = _a.requirements;
    return (React.createElement("div", { className: "flex flex--aligned flex--around " + IdStyles.MarketMenuRequirementsBackground }, requirements.map(function (resource) {
        var id = resource.id, amount = resource.amount;
        return React.createElement(InventoryResourceRequirement, { key: id, required: amount, resourceId: id });
    })));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/nursery/RequirementsRecipe.tsx
// module id = 2728
// module chunks = 3